/**
 * 3-letter codes for matrix / “sändnings”-stil (VM: ISO 3166-1 alpha-3 där det är vedertaget).
 * Klubbkoder (3 bokstäver) lämnas i versaler; okända 2-bokstavskoder → versaler som fallback.
 */
const A2_TO_A3 = {
  AR: "ARG",
  AT: "AUT",
  AU: "AUS",
  BA: "BIH",
  BE: "BEL",
  BR: "BRA",
  CA: "CAN",
  CH: "CHE",
  CI: "CIV",
  CD: "COD",
  CL: "CHL",
  CM: "CMR",
  CO: "COL",
  CV: "CPV",
  CW: "CUW",
  CZ: "CZE",
  DE: "DEU",
  DK: "DNK",
  DZ: "DZA",
  EC: "ECU",
  EG: "EGY",
  EN: "ENG",
  FR: "FRA",
  GH: "GHA",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  IR: "IRN",
  IQ: "IRQ",
  IT: "ITA",
  JO: "JOR",
  JP: "JPN",
  KR: "KOR",
  MA: "MAR",
  MX: "MEX",
  NG: "NGA",
  NL: "NLD",
  NO: "NOR",
  NZ: "NZL",
  PA: "PAN",
  PE: "PER",
  PL: "POL",
  PT: "PRT",
  PY: "PRY",
  QA: "QAT",
  RS: "SRB",
  SA: "SAU",
  SE: "SWE",
  SN: "SEN",
  TN: "TUN",
  TR: "TUR",
  UA: "UKR",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  ZA: "ZAF",
  SCT: "SCO",
  ES: "ESP",
};

export function toBroadcastTeamCode(code) {
  if (code == null || code === "") return "–";
  const raw = String(code).trim();
  if (!raw) return "–";
  const up = raw.toUpperCase();
  if (up.length >= 3) return up.slice(0, 3);
  return A2_TO_A3[up] || A2_TO_A3[raw] || up;
}

export function matchPairBroadcast(m) {
  const h = m.home_code ? toBroadcastTeamCode(m.home_code) : "–";
  const a = m.away_code ? toBroadcastTeamCode(m.away_code) : "–";
  return `${h}–${a}`;
}
